import DataTableHeaderPaymentInfo from './DataTableHeaderPaymentInfo';
import DataTableHeader from './DataTableHeader';
import DataTableBody from './DataTableBody';
import { Table } from '@/components/ui';

export const DataTable = () => (
  <div className='border rounded-md'>
    <Table>
      <DataTableHeaderPaymentInfo />
      <DataTableHeader />
      <DataTableBody />
    </Table>
  </div>
);

export default DataTable;
